import { gql } from "@apollo/client"

export const GET_COMPANIES = gql`
  query GetCompanies {
    getCompanies {
      id
      name
      title
      country_code
      company_country
      currency
      user_name
      app_name
    }
  }
`